export default function useEquipmentTypes() {
  const typeModes = {
    "DRY": "DRY",
    "DRY VAN": "DRY",
    "VAN": "DRY",
    "V53": "DRY",
    "V": "DRY",
    "REF": "REF",
    "REEFER": "REF",
    "REFER": "REF",
    "TEMP": "REF",
    "R53": "REF",
    "R": "REF",
    "FLAT": "FLAT",
    "BED": "FLAT",
    "FLATBED": "FLAT",
    "FLAT BED": "FLAT",
    "F": "FLAT",
    "VR": "DRYREF",
  };

  const typeLabels = [
    {
      id: "V53",
      label: "Dry Van"
    },
    {
      id: "R53",
      label: "Reefer"
    },
    {
      id: "F",
      label: "Flat Bed"
    },
    {
      id: "VR",
      label: "Van or Reefer"
    }
  ];

  const modeOptions = [
    {
      name: "Dry",
      value: "DRY"
    },
    {
      name: "Reefer",
      value: "REF"
    },
    {
      name: "Flatbed",
      value: "FLAT"
    },
    {
      name: "Dry Van & Reefer",
      value: "DRYREF"
    }
  ];

  const modesOptions = [
    "AIR",
    "DRAY",
    "DRY",
    "FLAT",
    "HAZ",
    "HAZIM",
    "HAZR",
    "IM",
    "LFTGT",
    "LTL",
    "PARTL",
    "PO",
    "FRZPR",
    "REFIM",
    "REF",
    "RLTL",
    "RTEAM",
    "STR",
    "SUB",
    "TONU",
    "VORFL",
    "VTEAM"
  ];

  const priorityTypes = ["V53", "R53"];

  return { typeModes, typeLabels, modeOptions, modesOptions, priorityTypes };
}